import { getPrinterDeviceTypes } from "../device_types/device_types";

export function getPrinters(region_id, building_id, area_id) {
    const results = { printers: [] }

    return getPrinterDeviceTypes().then((printer_device_types) => {
        // Map over the initial results and call getDevices for each one
        const getDevicePromises = printer_device_types.device_types.map(result => getDevices(result.id, region_id, building_id, area_id));

        // Wait for all query promises to complete
        return Promise.all(getDevicePromises).then((printers_json) => {
            for (const index in printers_json) {
                // Each getDevices method call returns an array of hashes. This flattens
                // those results from individual arrays into a single array.
                results.printers.push(...printers_json[index].devices);
            }

            return results;
        })
    })
}

export function getDevices(device_type_id = null, region_id = null, building_id = null, area_id = null) {
    const results = { devices: [] };
    let pagination_token = null;

    const execute_query = async PaginationToken => {
        if (PaginationToken) {
            pagination_token = PaginationToken;
        }

        // Issue the request
        return $.ajax({
            url: '/api/items/list',
            dataType: 'json',
            data: {
                device_type: device_type_id,
                region: region_id,
                building: building_id,
                area: area_id,
                pagination_token: pagination_token
            }
        }).promise().then((items_json) => {
            // Transform the items response to match the expected devices format
            const transformedDevices = items_json.data.items.map(item => {
                // Transform the item structure to match what the printer controller expects
                const transformedDevice = {
                    id: item.id,
                    name: item.name,
                    dns_name: item.dns_name,
                    ip_address: item.ip_address,
                    locale: {
                        area: item.locale.area.name
                    }
                };

                // Add device type information if it exists (for devices)
                if (item.device) {
                    transformedDevice.device_type = {
                        device_type: item.device.device_type.name,
                        manufacturer: item.device.manufacturer.name,
                        model: item.device.model.name
                    };
                }

                // Add tray mappings if they exist (for printers)
                if (item.tray_mappings) {
                    transformedDevice.tray_mappings = item.tray_mappings;
                }

                // Add print mappings if they exist (for workstations)
                if (item.print_mappings) {
                    transformedDevice.print_mappings = item.print_mappings;
                }

                return transformedDevice;
            });

            // Gather the results from this query and stash them in the output object
            results.devices.push(...transformedDevices);

            // Break out of this recursive loop if we've found everything
            if (items_json.data.pagination_token == null) {
                return results;
            }

            // If we haven't found everything, recurse again with the updated pagination token
            return execute_query(items_json.data.pagination_token);
        }).catch(error => {
            console.error(error);
            throw new Error('Error fetching devices. Please try again.');
        });
    };

    return execute_query();
}